/**
 * A faster and easier to debug version of the Chakra Tabs component. It does not render tab panels unless they are active.
 */
import {
  Tabs as ChakraTabs,
  TabList as ChakraTabList,
  Tab as ChakraTab,
  TabPanels as ChakraTabPanels,
  TabPanel as ChakraTabPanel,
} from "@chakra-ui/react";
import React, { useState } from "react";

/**
 * Pass props + index to the children.
 * @param {*} children
 * @param {*} props
 * @returns
 */
function passToChildren(children, props) {
  if (!children) return children;
  return React.Children.map(children, (child, index) => {
    const propsi = { ...props, index };
    if (React.isValidElement(child)) {
      return React.cloneElement(child, propsi);
    } else if (typeof child === "function") {
      return child(propsi);
    }
    return child;
  });
}

export function Tabs({ children, index, onChange, ...rest }) {
  const [activeTabIndex, setActiveTabIndex] = useState(index || 0);
  const kids = passToChildren(children, { activeTabIndex });
  const handleChange = (index) => {
    setActiveTabIndex(index);
    if (onChange) onChange(index);
  };
  return (
    <ChakraTabs {...rest} index={activeTabIndex} onChange={handleChange}>
      {kids}
    </ChakraTabs>
  );
}

export function TabList({ children, ...rest }) {
  return <ChakraTabList {...rest}>{children}</ChakraTabList>;
}

export function Tab({ children, ...rest }) {
  return <ChakraTab {...rest}>{children}</ChakraTab>;
}

export function TabPanels({ children, activeTabIndex, ...rest }) {
  const kids = passToChildren(children, { activeTabIndex });
  return <ChakraTabPanels {...rest}>{kids}</ChakraTabPanels>;
}

export function TabPanel({ children, activeTabIndex, index, ...rest }) {
  const isActive = index === activeTabIndex;
  return <ChakraTabPanel {...rest}>{isActive ? children : null}</ChakraTabPanel>;
}
